angular.module( 'acme.view.application.membership.offerings.create.policies', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.policies.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreatePolicies = {
        name: 'application.membership.offerings.create.policies',
        url: '/policies',
        views: {
          "subview-main": {
            controller: 'MembershipOfferingsCreatePoliciesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/policies/policies.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreatePolicies);
});
